import { computed, ref } from 'vue'

const openCanvases = ref(0)
const isImmersive = computed(() => openCanvases.value > 0)

function enter() {
  openCanvases.value += 1
}

function leave() {
  openCanvases.value = Math.max(0, openCanvases.value - 1)
}

function reset() {
  openCanvases.value = 0
}

export function useImmersiveView() {
  return { isImmersive, enter, leave, reset }
}
